<template lang="pug">
  WtTile(child :col="12").has-background-light
    WtTitle.mt-1.mb-1 Create New {{_.get(coreProgramMeta, "organizationsName", "Organization")}}
    .is-flex
      BInput.mt-3.mr-5.is-flex-grow-1(
        v-model="newOrganizationName"
        :placeholder="`${_.get(coreProgramMeta, 'organizationsName', 'Organization')} Name`"
        size="is-medium"
      )
      WtButton.mt-3(
        bold
        color="primary"
        size="medium"
        @click.native="addNewOrganization()"
        :disabled="!newOrganizationName || processing"
      ) Create
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtButton from "@@/WtButton/WtButton";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "CreateOrganization",

  components: {
    WtTitle,
    WtTile,
    WtButton
  },

  data() {
    return {
      newOrganizationName: null,
      processing: false
    };
  },
  computed: {
    ...mapGetters("program", ["coreProgramMeta"])
  },
  methods: {
    ...mapActions("organizations", ["addOrganization"]),
    ...mapActions(["snackBar"]),

    async addNewOrganization() {
      if (this.newOrganizationName) {
        this.processing = true;
        try {
          await this.addOrganization({
            programId: this.coreProgramMeta.id,
            name: this.newOrganizationName
          });
          this.snackBar({
            duration: 5000,
            type: "is-success",
            message: `Organization successfully created!`
          });
          this.newOrganizationName = null;
          this.processing = false;
        } catch (err) {
          if (err.status !== 500) {
            this.snackBar({
              type: "is-danger",
              message: err.data.error.message
            });
          } else {
            this.snackBar({
              type: "is-danger",
              message: `There was an error. Please contact wellness@be-engaged.co`
            });
          }
          this.processing = false;
        }
      }
    }
  }
};
</script>

<style lang="sass"></style>
